var render, staticRenderFns
import script from "./mob-basic.vue?vue&type=script&lang=js"
export * from "./mob-basic.vue?vue&type=script&lang=js"
import style0 from "./mob-basic.vue?vue&type=style&index=0&id=c957644c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c957644c",
  null
  
)

export default component.exports